import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateEmployeeSalary, updateEmployeeWorkHours } from '../../services/adminService';
import { showToast, showError } from '../../utils/sweetAlert';
import { formatCurrency } from '../../utils/format';
import './EmployeeCard.css';

const EmployeeCard = ({ employee, onUpdate }) => {
  const navigate = useNavigate();
  const [salary, setSalary] = useState(employee.salary);
  const [workHours, setWorkHours] = useState(employee.workHours);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (field) => {
    try {
      setLoading(true);

      if (field === 'salary') {
        await updateEmployeeSalary(employee._id, salary);
      } else if (field === 'workHours') {
        await updateEmployeeWorkHours(employee._id, workHours);
      }

      onUpdate(); // Refresh list
      showToast(`${field === 'salary' ? 'Salary' : 'Work Hours'} updated successfully!`);
    } catch (error) {
      showError('Update Failed', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="employee-card-new">
      <div className="card-header-new">
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{
              width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#e2e8f0',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              overflow: 'hidden', border: '2px solid #cbd5e1', flexShrink: 0
          }}>
              {employee.profilePhoto ? (
                  <img src={employee.profilePhoto} alt={employee.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                  <span style={{ fontSize: '1.5rem', color: '#94a3b8' }}>👤</span>
              )}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="header-top">
              <h3 style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{employee.name}</h3>
              <span className="employee-type-badge">{employee.employeeType || 'Full Time'}</span>
            </div>
            <p className="employee-email" style={{ margin: '4px 0 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{employee.email}</p>
            <p className="employee-department" style={{ margin: '4px 0 0', fontSize: '0.85rem', color: '#64748b' }}>
              <span style={{ fontWeight: '500' }}>Dept:</span> {employee.department || 'General'}
            </p>
            {employee.status === 'terminated' && (
              <span className="status-badge terminated" style={{ marginTop: '4px', display: 'inline-block' }}>Terminated</span>
            )}
          </div>
        </div>
      </div>

      <div className="card-body-new">
        {/* Salary Section */}
        <div className="input-group">
          <label>Salary</label>
          <div className="input-row">
            <input
              type="number"
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
              disabled={loading}
            />
            <button
              className="btn-update"
              onClick={() => handleUpdate('salary')}
              disabled={loading || Number(salary) === Number(employee.salary)}
            >
              Update
            </button>
          </div>
          <small className="current-val">Current: {formatCurrency(employee.salary)}</small>
        </div>

        {/* Work Hours Section */}
        <div className="input-group">
          <label>Work Hours (per day)</label>
          <div className="input-row">
            <input
              type="number"
              value={workHours}
              onChange={(e) => setWorkHours(e.target.value)}
              disabled={loading}
            />
            <button
              className="btn-update"
              onClick={() => handleUpdate('workHours')}
              disabled={loading || Number(workHours) === Number(employee.workHours)}
            >
              Update
            </button>
          </div>
          <small className="current-val">Current: {employee.workHours} hrs/day</small>
        </div>
      </div>

      <div className="card-footer-new">
        <button
          className="btn-manage"
          onClick={() => navigate(`/admin/employees/${employee._id}`)}
        >
          Manage & View Details
        </button>
      </div>
    </div>
  );
};

export default EmployeeCard;
